import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: '#f9fafb',
            color: '#111827',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <h1 style={{ marginBottom: 16, fontSize: 24 }}>Ошибка загрузки приложения</h1>
          <p style={{ marginBottom: 24, color: '#6b7280' }}>
            {this.state.error?.message || 'Неизвестная ошибка'}
          </p>
          <a href="/" style={{ color: '#2563eb', fontWeight: 500 }}>
            Перейти на главную
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}
